export default function calculateClimateScore(inventory) {
  var totalCarbon = 0;
  var itemsUsed = 0;
  var itemsNotUsed = 0;
  let counterObj = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, none: 0, display: false };
  if (inventory !== null) {
    inventory.forEach((item) => {
      if (item.carbon_fp) {
        if (!counterObj["display"]) {
          counterObj["display"] = true;
        }
        counterObj[item.carbon_fp.climateScore] += 1;
        totalCarbon += item.carbon_fp.climateScore * item.quantity;
        itemsUsed += item.quantity;
      } else {
        counterObj["none"] += 1;
        itemsNotUsed += item.quantity;
      }
    });
  }

  if (itemsUsed === 0 && itemsNotUsed === 0) {
    return { climateAvg: 0, itemsUsed: 0, itemsNotUsed: 0, counterObj };
  } else if (itemsUsed === 0 && itemsNotUsed !== 0) {
    return {
      climateAvg: 0,
      itemsUsed: 0,
      itemsNotUsed: itemsNotUsed,
      counterObj,
    };
  } else {
    return {
      climateAvg: (totalCarbon / itemsUsed).toFixed(2),
      itemsUsed: itemsUsed,
      itemsNotUsed: itemsNotUsed,
      counterObj,
    };
  }
}
